export default __webpack_public_path__ + "assets/audios/bbe9392bb2079018b2759f973c642263.mp3";